module.exports = __webpack_public_path__ + "static/media/e-selection.7b0a2d1d.png";